import appReducer from 'store/reducers';
import { configureStore } from '@reduxjs/toolkit';

export default configureStore({
  reducer: appReducer,
});

export const setupStore = (preloadedState) => {
  return configureStore({
    reducer: appReducer,
    preloadedState,
  });
};
